import React, { useEffect, useState } from 'react';
import { WhosOnline } from '../room/types';
import { ValorantButton } from './ValorantButton';

let timeout: any;

type PropTypes = {
  connected?: boolean;
  disablePlayButton: boolean;
  maintenanceScheduled: boolean;
  onlinePlayer?: WhosOnline;
  openPlayMenu: boolean;
  onPlayClick: (onlinePlayer?: WhosOnline) => void;
  seedMatch: number;
  small?: boolean;
  soloMultiAsync: 'solo' | 'multiplayer' | 'teams' | 'async';
  voluntarySeedMatch: boolean;
};

export const PlayButton2 = ({
  connected,
  disablePlayButton,
  maintenanceScheduled,
  onlinePlayer,
  openPlayMenu,
  onPlayClick,
  seedMatch,
  small,
  soloMultiAsync,
  voluntarySeedMatch,
}: PropTypes) => {
  const [playButtonZIndex, setPlayButtonZIndex] = useState(0);
  const [playClicked, setPlayClicked] = useState(false);

  useEffect(() => {
    if (!openPlayMenu) {
      setPlayClicked(false);
      // hack to make it seem like the play button never goes behind the drawer
      // during the drawer closing animation
      timeout = setTimeout(() => {
        setPlayButtonZIndex(0);
      }, 1000);
      return;
    }
    clearTimeout(timeout);
    setPlayButtonZIndex(99999);
  }, [openPlayMenu]);

  const displayLabel = onlinePlayer?.gameInProgress
    ? 'REJOIN'
    : !openPlayMenu
    ? 'PLAY'
    : soloMultiAsync === 'solo'
    ? 'START SOLO'
    : soloMultiAsync === 'multiplayer'
    ? 'CREATE SNG'
    : soloMultiAsync === 'teams'
    ? 'CREATE TEAMS'
    : (soloMultiAsync === 'async' && seedMatch === 0) || voluntarySeedMatch
    ? 'SEED MATCH'
    : 'SEARCH MATCH';

  const loadingLabel =
    soloMultiAsync === 'solo'
      ? 'STARTING..'
      : soloMultiAsync === 'multiplayer'
      ? 'CREATING..'
      : soloMultiAsync === 'teams'
      ? 'CREATING..'
      : (soloMultiAsync === 'async' && seedMatch === 0) || seedMatch
      ? 'SEEDING..'
      : 'SEARCHING..';

  const handlePlayClick = (onlinePlayer: WhosOnline) => {
    if (openPlayMenu) {
      setPlayClicked(true);
    }
    onPlayClick(onlinePlayer);
  };

  return (
    <ValorantButton
      buttonZIndex={playButtonZIndex}
      disabled={disablePlayButton || playClicked}
      label={displayLabel}
      loading={playClicked}
      loadingLabel={loadingLabel}
      onClick={() => handlePlayClick(onlinePlayer)}
      small={small}
      showAnimation={!openPlayMenu && !onlinePlayer?.gameInProgress}
    />
  );
};
